import { Navigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { Loader2 } from 'lucide-react';
import { OnboardingRedirect } from '../redirects/onboarding-redirect';
import { trpc } from '@/lib/api/trpc';

/**
 * Component that redirects to the first available account
 * Used for root and /orgs routes
 * Now integrated with onboarding system
 */
export function OrgRedirect() {
  const { isSignedIn, isLoaded: authLoaded } = useAuth();

  const { data: userCheck, isLoading: isCheckingUser } = trpc.users.checkUserExists.useQuery(
    undefined,
    { enabled: authLoaded && !!isSignedIn },
  );

  // Wait for auth to load first
  if (!authLoaded) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <Loader2 className="text-muted-foreground mx-auto h-8 w-8 animate-spin" />
          <p className="text-muted-foreground mt-4 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  // If not signed in, redirect to sign-in page
  if (!isSignedIn) {
    return <Navigate to="/sign-in" replace />;
  }

  // Wait for DB user check
  if (isCheckingUser) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <Loader2 className="text-muted-foreground mx-auto h-8 w-8 animate-spin" />
          <p className="text-muted-foreground mt-4 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  // Clerk user exists but no DB user — redirect to complete profile
  if (userCheck && !userCheck.exists) {
    return <Navigate to="/complete-profile" replace />;
  }

  return <OnboardingRedirect />;
}
